export const FULL_DATE_TIME_FORMAT = 'dd MMM yyyy HH:mm';
export const SHORT_MONTH_FORMAT = 'dd MMM yyyy';
